module.exports = __webpack_public_path__ + "img/0028.d60607c5.jpg";